const Map = () => (
  <section className="w-full h-96">
    <iframe
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3529.5622498730477!2d-64.25771351114504!3d-27.792459299999987!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x943b52057681d3d1%3A0x473028370be3c57e!2sEstadio%20Ciudad%20Quimsa!5e0!3m2!1ses-419!2scl!4v1748366564341!5m2!1ses-419!2scl"
      className="w-full h-full border-0"
      allowFullScreen=""
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
      title="Estadio Ciudad Quimsa"
    ></iframe>
  </section>
);

export default Map;
